// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"704860cd","787":"bbdb2914","802":"a09d9aad"}[chunkId] + ".chunk.js";
};